import { BookmarkSimple } from '@phosphor-icons/react';

export default BookmarkSimple;
